"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refundWithDebitRequestSchema = exports.listRefundsRequestSchema = exports.updateRefundRequestSchema = exports.createRefundRequestSchema = exports.refundDebitParamsSchema = exports.refundIdParamsSchema = void 0;
const zod_1 = require("zod");
const base_js_1 = require("../common/base.js");
const refundReturnItemsSchema = zod_1.z.union([base_js_1.looseObjectSchema, zod_1.z.array(base_js_1.looseObjectSchema)]);
exports.refundIdParamsSchema = zod_1.z.object({ refundId: zod_1.z.string().min(1) }).strict();
exports.refundDebitParamsSchema = zod_1.z
    .object({
    paymentIntentId: zod_1.z.string().min(1),
    terminalId: zod_1.z.string().min(1),
})
    .strict();
exports.createRefundRequestSchema = zod_1.z
    .object({
    charge: zod_1.z.string().optional(),
    amount: zod_1.z.coerce.number().int().positive().optional(),
    payment_intent: zod_1.z.string().optional(),
    metadata: base_js_1.looseObjectSchema.optional(),
    reason: zod_1.z.string().optional(),
    returnItems: refundReturnItemsSchema.optional(),
    receipt_email: base_js_1.emailSchema.optional(),
})
    .strict();
exports.updateRefundRequestSchema = zod_1.z
    .object({
    metadata: base_js_1.looseObjectSchema.optional(),
})
    .strict();
exports.listRefundsRequestSchema = zod_1.z
    .object({
    charge: zod_1.z.string().optional(),
    payment_intent: zod_1.z.string().optional(),
    created: zod_1.z.union([zod_1.z.coerce.number().int(), base_js_1.looseObjectSchema]).optional(),
    ending_before: zod_1.z.string().optional(),
    limit: zod_1.z.coerce.number().int().positive().max(100).optional(),
    starting_after: zod_1.z.string().optional(),
})
    .strict();
exports.refundWithDebitRequestSchema = zod_1.z
    .object({
    amount: zod_1.z.coerce.number().int().positive(),
    returnItems: refundReturnItemsSchema.optional(),
    metadata: base_js_1.looseObjectSchema.optional(),
})
    .strict();
//# sourceMappingURL=refund.schemas.js.map